import { Separator } from '@/components/atoms/Separator';
import { Skeleton } from '@/components/atoms/Skeleton';
import PaginaVendaMobileFallback, {
  CheckoutContainerFallback,
} from '@/components/templates/PaginaVendaMobileTemplate/fallback';
import { theme } from '@/styles/theme';
import { Fragment } from 'react';

export default function ServicoAssinaturaPaginaMobileFallback() {
  return (
    <Fragment>
      <PaginaVendaMobileFallback
        $fallbackConteudoDescritivo={
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              padding: theme.spacing[4],
              gap: theme.spacing[4],
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: theme.spacing[4],
              }}
            >
              <Skeleton style={{ height: 40, width: 40 }} />
              <Skeleton style={{ height: 20, width: 140 }} />
            </div>
            <Skeleton style={{ height: 210 }} />
            <Separator $block={false} $orientation="horizontal" />
            <Skeleton style={{ height: 200 }} />
          </div>
        }
      />
      <CheckoutContainerFallback />
    </Fragment>
  );
}
